import {
  createMaterialTopTabNavigator,
  MaterialTopTabNavigationEventMap,
  MaterialTopTabNavigationOptions
} from "expo-router/js-top-tabs";
import { TabNavigationState } from "expo-router/react-navigation";
import { withLayoutContext } from 'expo-router';
import { Platform, StyleSheet, useWindowDimensions, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import TabBarLabel from '@/components/TabBarLabel';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { ParamListBase } from '@/types/navigation';
import { i18n } from '@/utils/i18n';
import HeaderBar from '@/components/HeaderBar';

const { Navigator } = createMaterialTopTabNavigator();
export const MaterialTopTabs = withLayoutContext<
  MaterialTopTabNavigationOptions,
  typeof Navigator,
  TabNavigationState<ParamListBase>,
  MaterialTopTabNavigationEventMap
>(Navigator);

export default function EngageLayout() {
  const { width: screenWidth } = useWindowDimensions();
  const colors = useColor();

  return (
    <SafeAreaView edges={Platform.OS === 'ios' ? ['top'] : []} style={styles.flexOne}>
      {/* md breakpoint --> 768 px */}
      {Platform.OS !== 'web' || screenWidth < 768 ? (
        <HeaderBar screenTitle={i18n.t('bottom_tab.engage')} />
      ) : (
        <View style={styles.topBar}>
          <Text style={[styles.title, { color: colors.titleText }]}>{i18n.t('bottom_tab.engage')}</Text>
        </View>
      )}
      <MaterialTopTabs
        screenOptions={{
          tabBarContentContainerStyle: {
            backgroundColor: colors.background
          },
          tabBarIndicatorStyle: { display: 'none' },
          tabBarStyle: styles.tabBarStyle,
          swipeEnabled: false,
          tabBarAndroidRipple: {
            color: 'transparent'
          }
        }}>
        <MaterialTopTabs.Screen
          name="volunteerEngage"
          options={{
            tabBarLabel: ({ focused }: any) => <TabBarLabel focused={focused} side="left" text={'engage.volunteer'} />
          }}
        />
        <MaterialTopTabs.Screen
          name="trending"
          options={{
            tabBarLabel: ({ focused }: any) => <TabBarLabel focused={focused} side="right" text={'engage.trending'} />
          }}
        />
      </MaterialTopTabs>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  topBar: {
    height: 38,
    flexDirection: 'row',
    alignItems: 'center'
  },

  title: {
    flex: 1,
    textTransform: 'capitalize',
    fontWeight: '700',
    fontSize: 20,
    textAlign: 'center'
  },

  tabBarStyle: {
    shadowOpacity: 0,
    shadowColor: 'transparent',
    width: 290,
    alignSelf: 'center',
    marginBottom: 20
  },

  flexOne: {
    flex: 1
  }
});
